module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('div', {
    staticClass: "type-wrap"
  }, [_c('router-link', {
    staticClass: "skip",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页>")]), _vm._v(" "), _c('router-link', {
    staticClass: "skip",
    attrs: {
      "to": _vm.type == 1 ? '/about/perspective' : '/about/culture'
    }
  }, [_vm._v(_vm._s(_vm.type == 1 ? '伟嘉视角>' : '企业文化>'))]), _vm._v(" "), _c('span', {
    staticClass: "type-name"
  }, [_vm._v("详情")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-content"
  }, [_c('h3', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.info.title))]), _vm._v(" "), _c('p', {
    staticClass: "articles-top text-right",
    staticStyle: {
      "font-weight": "900"
    }
  }, [_c('span', [_vm._v("发布日期：" + _vm._s(_vm.info.addDate))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.info.content)
    }
  })]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v("文章详情")]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v("ARTICLE DETAILS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1b6e31c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/articles.vue
// module id = 587
// module chunks = 1